import { Logo } from '@ui';
import styles from './Brand.module.css';

/** swarm logo and word mark (issue #175), optionally with the business name below. */
export function Brand({
  large = false,
  business,
}: {
  large?: boolean;
  business?: string | null | undefined;
}) {
  return (
    <span className={`${styles.brand} ${large ? styles.large : ''}`}>
      <span className={styles.product}>
        <Logo size={large ? 56 : 24} />
        swarm
      </span>
      {business && <span className={styles.business}>{business}</span>}
    </span>
  );
}
